<template>
<div class="px-4 pt-6 pb-10 mx-auto max-w-5xl lg:pb-4 xl:px-0">
    <div class="bg-[#FFF4E1] lg:py-12 sm:py-10 py-6 lg:px-12 sm:px-10 px-4">
        <div class="flex flex-col gap-x-10 md:gap-y-4 md:flex-row">
            <div class="grid items-start md:basis-52 basis-48">
                <nuxt-img class="mx-auto md-max:w-32" :src="badgeImage" :width="badgeWidth"
                :height="badgeHeight" format="webp" loading="lazy" :sizes="badgeSizes" :alt="badgeAlt" />
            </div>
            <div class="w-full">
                <div class="mb-4 text-2xl text-center md:text-3xl xl:text-32 font-ww-bold" v-html="heading">
                </div>
                <div class="lg:text-lg text-base text-center font-ww-regular !leading-6" v-html="description">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
defineProps({
  badgeImage: {
    type: String,
    default: '/assets/images/90-days-risk-free.png'
  },
  badgeWidth: {
    type: Number,
    default: 152
  },
  badgeHeight: {
    type: Number,
    default: 194
  },
  badgeSizes: {
    type: String,
    default: 'xs:152px sm:152px md:152px lg:152px xl:152px'
  },
  badgeAlt: {
    type: String,
    default: '90 Days Risk Free Guarantee'
  },
  heading: {
    type: String,
    default: 'The 90-Day "Hide-It-from-Your-Grandma" Guarantee'
  },
  description: {
    type: String,
    default: 'The high-quality ingredients in Mindflow work synergistically together to give you all-day clean energy, better focus, and improved performance. You get all this without the jitters, crashes, and slumps common with low-quality coffees, sugary lattes, and chemical-loaded energy drinks.<br><br>If you don\'t love how you feel and love the taste of Mindflow so much that you hide every bag from your family, including your grandma so they don\'t steal your Mindflow…we\'ll give you a 100% refund.<br><br>Just return the bags, open or unopened, to us anytime in the next 90 days. We\'ll give you a 100% refund. No hassle. No questions. No problems.'
  }
})

defineBuilderComponent({
    friendlyName: 'Text Description with Badge',
    canHaveChildren: false,
    inputs: [
        {
            name: 'badgeImage',
            type: 'file',
            defaultValue: '/assets/images/90-days-risk-free.png'
        },
        {
            name: 'badgeWidth',
            type: 'number',
            defaultValue: 152
        },
        {
            name: 'badgeHeight',
            type: 'number',
            defaultValue: 194
        },
        {
            name: 'badgeSizes',
            type: 'text',
            defaultValue: 'xs:152px sm:152px md:152px lg:152px xl:152px'
        },
        {
            name: 'badgeAlt',
            type: 'text',
            defaultValue: '90 Days Risk Free Guarantee'
        },
        {
            name: 'heading',
            type: 'richText',
            defaultValue: 'The 90-Day "Hide-It-from-Your-Grandma" Guarantee'
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: 'The high-quality ingredients in Mindflow work synergistically together to give you all-day clean energy, better focus, and improved performance. You get all this without the jitters, crashes, and slumps common with low-quality coffees, sugary lattes, and chemical-loaded energy drinks.<br><br>If you don\'t love how you feel and love the taste of Mindflow so much that you hide every bag from your family, including your grandma so they don\'t steal your Mindflow…we\'ll give you a 100% refund.<br><br>Just return the bags, open or unopened, to us anytime in the next 90 days. We\'ll give you a 100% refund. No hassle. No questions. No problems.'
        }
    ]
})
</script>